<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单审批'}]"
                    v-if="this.taskstatus == '0'"/>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单详情'}]"
                    v-if="this.taskstatus == '1'"/>
            <div>
                <!---------------------------------------------------项目信息-------------------------------------------------------------------->
                <div class="h-piece">
                    <div class="h-pieceIn2 n-xiao" v-if="order.orderProjectCode && !showService && order.category1Name != '工程订单'">
                        <div class="h-pieceTitle2 " style="margin-left:10px">
                            <h1>项目信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                            <div class="h-formLine">
                                <el-form :model="order" label-position="right" :inline="true"
                                         class="demo-ruleForm h-formbLine">
                                    <el-form-item label="项目名称" class="h-elformWrap-2">
                                        <el-input v-model="order.orderProjectName" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="项目版本号" class="h-elformWrap-2">
                                        <el-input v-model="order.orderProjectCode" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="项目合同编号" class="h-elformWrap-2">
                                        <el-input v-model="order.orderSubContract" readonly></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                    <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
                    <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

                    <div class="h-pieceIn2">
                        <div class="h-pieceTitle2" style="margin-left:10px">
                            <h1>订单信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                            <div class="h-formLine n-two">
                                <el-form label-position="right" :inline="true"
                                         class="demo-ruleForm h-formbLine">
                                    <el-form-item label="项目名称" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                        <el-input v-model="order.orderProjectName" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="项目版本号" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                        <el-input v-model="order.orderProjectCode" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="项目备注" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                        <el-input v-model="order.projectDescription" readonly :title="order.projectDescription"></el-input>
                                    </el-form-item>
                                    <el-form-item label="订单类型" class="h-elformWrap-2">
                                        <el-input v-model="xsqyStr" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="创建人" class="h-elformWrap-2">
                                        <el-input v-model="this.order.cuname" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="创建时间" class="h-elformWrap-2">
                                        <el-input v-model="this.order.cdate" readonly></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                    <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

                    <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
                    <div class="h-pieceIn2">
                        <div class="h-pieceTitle2" style="margin-left:10px">
                            <h1>客户信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                            <div class="h-formLine n-two">
                                <el-form :model="order" ref="form1" label-position="right" :inline="true"
                                         class="demo-ruleForm h-formbLine">
                                    <el-form-item prop="soldToName" label="售达方名称"
                                                  class="h-elformWrap-2">
                                        <el-input v-model="order.soldToName" readonly/>
                                    </el-form-item>

                                    <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2" >
                                        <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                                    </el-form-item>
                                    <el-form-item label="售达方销售区域" class="h-elformWrap-2">
                                        <el-input v-model="order.salesregionName" readonly placeholder="自带出"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="customerChannelCode" label="客户渠道" class="h-elformWrap-2">
                                        <brselect
                                                :disabled="true"
                                                category="sales_region" :v="order.customerChannelCode"
                                                v-model="order.customerChannelCode"></brselect>
                                    </el-form-item>

                                    <el-form-item prop="isStockUp" label="是否备货" class="h-elformWrap-2" >
                                        <brselect category="shifou_keyong" disabled :v="order.isStockUp"
                                                  v-model="order.isStockUp"></brselect>
                                    </el-form-item>
                                    <el-form-item prop="toCompanyname" label="收货单位" class="h-elformWrap-2"  >
                                        <el-input v-model="order.toCompanyname" :class="{'addredclass':regionaddflag}" readonly></el-input>
                                    </el-form-item>

                                    <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                        <el-input v-model="order.contactName" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item
                                            label="预计收货日期"
                                            class="h-elformWrap-2"
                                            prop="receivedTime">
                                        <div class="block">
                                            <el-input v-model="order.receivedTime" readonly></el-input>
                                        </div>
                                    </el-form-item>

                                    <el-form-item label="联系电话" class="h-elformWrap-2" prop="firsttelephone">
                                        <div class="block">
                                            <el-input v-model="order.firsttelephone" readonly
                                            ></el-input>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="收货地址" prop="toAddress" class="h-elformWrap-2" >
                                        <el-input  v-model="order.toAddress" readonly style="width: 600px;">
                                        </el-input>
                                    </el-form-item>

                                </el-form>
                            </div>
                        </div>
                    </div>
                    <!-------------------------------------------------------客户信息-------------------------------------------------------------------->


                    <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
                    <div  class="h-table h-mrt30 ljjtablepaddings" style="margin: 20px 20px 0 20px;">
                        <div class="h-pieceTitle2 message">
                            <h1>发货产品信息</h1>
                        </div>
                        <div>
                            <el-table
                                    ref="multipleTable"
                                    @selection-change="handleSelectionChange9370"
                                    :data="productlist9390"
                                    stripe
                                    border
                                    style="width: 100%">
                                <el-table-column
                                        type="selection"
                                        width="40"
                                        label="全选">
                                </el-table-column>
                                <el-table-column
                                        type="index"
                                        label="#"
                                        width="40">
                                </el-table-column>
                                <el-table-column
                                        prop="proModelName"
                                        label="产品大类"
                                        :show-overflow-tooltip="true"
                                        width="110">
                                </el-table-column>
                                <el-table-column
                                        prop="sapCode"
                                        label="订单号"
                                        :show-overflow-tooltip="true"
                                        width="120">
                                </el-table-column>
                                <el-table-column
                                        prop="materialCode"
                                        label="产品编码"
                                        :show-overflow-tooltip="true"
                                        width="160">
                                </el-table-column>
                                <el-table-column
                                        prop="materialName"
                                        label="产品名称"
                                        min-width="190"
                                        :show-overflow-tooltip="true">
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">
                                            {{scope.row.materialName}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="proNumber"
                                        label="订单数量"
                                        width="100">
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{scope.row.proNumber}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        v-if="showRent"
                                        prop="cwddh"
                                        label="财务订单号"
                                        width="140">
                                </el-table-column>
                                <el-table-column
                                        prop="proBenchmarkPrice"
                                        :label="priceName"
                                        width="110">
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{scope.row.proBenchmarkPrice}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="currencyCode"
                                        label="币种"
                                        width="80">
                                </el-table-column>
                                <el-table-column
                                        v-if="tejieshowflag"
                                        prop="specialPrice"
                                        label="特价"
                                        width="120"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{scope.row.specialPrice}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        v-if="tejieshowflag"
                                        prop="sid"
                                        label="特价版本号"
                                        min-width="210"
                                >
                                </el-table-column>
                                <el-table-column
                                        v-if="tejieshowflag"
                                        prop="projectName"
                                        label="特价项目名称"
                                        min-width="180"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">
                                            {{scope.row.projectName}}
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        prop="finalPrice"
                                        label="成交价"
                                        width="110">
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{scope.row.finalPrice}}
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        prop="taxRate"
                                        label="税率"
                                        v-if="this.order.orderCategory1 == 9"
                                        width="110">
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{new big(scope.row.taxRate||0).times(100).minus(100).toString() + '%'}}
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        prop="jinejjz"
                                        label="净价值"
                                        width="110">
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{scope.row.jinejjz}}
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        prop="totalprice"
                                        label="总价"
                                        width="110"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{scope.row.totalprice}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="note1"
                                        label="备注"
                                        :show-overflow-tooltip="true"
                                        width="110"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: right;">
                                            {{scope.row.note1}}
                                        </div>
                                    </template>
                                </el-table-column>

                            </el-table>
                            <div class="jieguo" >
                                <span class="jieguo_label">订单总价</span>
                                <span class="jieguo_value">{{ order9390.orderPrice }}</span>
                                <span class="jieguo_label">净价值</span>
                                <span class="jieguo_value">{{ order9390.orderNetWorth }}</span>
                            </div>
                        </div>




                    </div>


                    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
                </div>
                <div class="h-table h-mrt30    bbbb"  >
                    <div class="h-pieceTitle2 hang">
                        <h1 class="h1">审批意见</h1>
                        <el-form :model="spform" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine ">
                            <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" :required="true">
                                <el-input v-model="spform.shpyj" placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="anniu" v-if="this.taskstatus == '0' ">
                    <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>
                    <el-button class="el-button h-btn h-bBtn h-bgred el-button--default"
                               @click="saveOrSubmit(2)">驳回
                    </el-button>
                    <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="saveOrSubmit(1)">通过
                    </el-button>
                    <el-button class="el-button h-btn el-button--default"
                               @click="viewpress">审批跟踪
                    </el-button>
                </div>
                <div class="anniu" v-if="this.taskstatus == '1'">
                    <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>
                    <el-button class="el-button h-btn el-button--default"
                               @click="viewpress">审批跟踪
                    </el-button>
                </div>
            </div>
    </div>
</template>
        <script>
            import big from 'big.js'
            import ss from '../../api/SystemService'


            export default {
                props:["orderid","orderinstid","ordertaskid","ordertaskstatus"],
                filters: {
                    numFilter(value) {
                        let realVal = ''
                        if (value) {
                            // 截取当前数据到小数点后两位
                            realVal = parseFloat(value).toFixed(2) * 100 + '%'
                        } else {
                            realVal = '--'
                        }
                        return realVal
                    }
                },
                data() {
                    return {
                        regionaddflag:false,
                        showRent : false,
                        shenqingzuofeiList: [],
                        //选中的
                        selectedList: [],
                        //作废弹窗
                        zfyydialogFormVisible:false,
                        //作废原因
                        zuofeiyy:null,
                        chooseOrder9390:[],
                        chooseOrder9370:[],
                        chooseOrder9391:[],
                        priceName: "基准价",
                        costList: [],
                        costList9390: [],
                        showSamplePro: false,
                        showshouhouflag: false,
                        aflag: false,
                        instid: null,
                        tejieshowflag: false,
                        dingzhishowflag: false,
                        spform: {
                            ywid: null,
                            taskid: null,
                            taskstatus: null,
                            optflag: null,
                            shpyj: null,
                            shouyiarea: null,
                            orderMainProductList: null,
                        },
                        showhistory: false,
                        //确认收益展示
                        showshouyiList: false,
                        shouyiList: [],//选择地址
                        qyjlspyj:null,//区域经理审批意见
                        shouyiareacode:null,//收益区域
                        order: {
                            id: null, // 主键
                            orderMainContract: null, // 主合同编号
                            orderSubContract: null, // 分合同编号
                            orderProjectCode: null, // 项目编号
                            orderProjectName: null, // 项目名称
                            projectDescription: null, // 项目描述
                            orderCategory: null, // 订单类型
                            orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
                            saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                            disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                            zCode: null, // 分销渠道编码-子编码
                            customerChannelCode: null, // 客户渠道
                            isStockUp: null, // 是否备货      1：是；0：否
                            orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                            instid: null, // 流程id
                            tuihyy: null, // 退货原因
                            tuihyydes: null, // 退货原因说明
                            contactName: null, // 联系人名称
                            receivedTime: null, // 预计收货时间
                            soldToCode: null, // 售达方编码
                            soldToName: null, // 售达方名称
                            salesregion: null, // 售达方销售名称
                            soldToAreaCode: null, // 售达方地区编码
                            shipToCode: null, // 送达方编码
                            shipToName: null, // 送达方名称
                            shipToAreaCode: null, // 送达方地区编码
                            invoiceCode: null, // 开票方编码
                            payerCode: null, // 付款方编码
                            currencyCode: null, // 币种编码
                            orderPrice: 0, // 订单总价
                            creditid: null, // 信贷id
                            orderNetWorth: 0, // 订单净价值
                            poId: null, // PO号
                            areaId: null, // 区域详情表关联id
                            dcCode: null, // 配送中心编码
                            toProvincesCode: null, // 送达省份编码
                            toCityCode: null, // 送达城市编码
                            note: null, // 订单备注
                            postcode: null, // 邮政编码
                            firsttelephone: null, // 第一个电话
                            secondtelephone: null, // 第二电话
                            extraPrice: null, // 定制加价
                            customized: null, // 定制需求
                            sapsended: null, // 是否已提交sap,1-是,0-否
                            toAddress: null, // 收货地址
                            toCompanyname: null, // 送达方公司全称

                            categoryName: null,
                            category1Name: null,
                            saleGrputName: null,
                            disChannelName: null,
                            zcodeName: null,

                        },
//行项目
                        productlist9390: [],

                        order9390: {
                            orderPrice:0,
                            orderNetWorth:0,
                        },
                        //产品list
                        productlist2: [],
                        gscode: null,

                        //用户信贷list
                        creditData: [],

                    }
                },
                //页面加载前事件
                created() {
                    let id = this.$route.query.ywid || this.$route.query.id;
                    let instid = this.$route.query.instid;
                    let taskid = this.$route.query.taskid;
                    let taskstatus = this.$route.query.taskstatus;
                    this.instid = instid
                    this.taskstatus = taskstatus
                    this.spform.ywid = id;
                    this.spform.taskid = taskid
                    this.getOrder(id,taskid);
                },
                computed: {
                    xsqyStr() {
                        if (this.order.category1Name) {
                            return this.order.categoryName + "/" + this.order.category1Name
                        }
                        return this.order.categoryName
                    },
                    xszzStr() {
                        return "(" + this.gscode + ")" + this.$store.getters.dictname('YLSalesOrganization_agent', this.gscode);
                    },
                    fxqdStr() {
                        if (this.order.zcodeName) {
                            return this.order.disChannelName + "/" + this.order.zcodeName
                        }
                        return this.order.disChannelName
                    },
                    total() {
                        return this.rows.map(
                            row => row.purchaseCount * row.price).reduce(
                            (acc, cur) => (parseFloat(cur) + acc), 0)
                    }
                },

                watch: {
                    productlist9390: {
                        immediate: true,
                        deep: true,
                        handler(newValue, oldValue) {
                            //计算总金额
                            this.order9390.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                                return new big(sum).plus(v).toString();
                            }, 0)
                              //计算总净价值
                            this.order9390.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                                return new big(sum).plus(v).toString();
                            }, 0)
                        },
                    },
                },

                methods: {

                    handleSelectionChange9390(v){
                        this.chooseOrder9390 = v;
                        this.selectedList = v;
                    },

                    getOrder(id,taskid) {
                        ss.OrderMainService.selectById(id,taskid).then(rd => {
                            this.regionaddflag = rd.obj.regionadd;
                            _.assign(this.order, rd.obj)
                            let type = this.order.orderCategory1;
                            //存在行项目
                            if (rd.obj.products && rd.obj.products.length > 0) {
                                rd.obj.products.forEach((obj) => {
                                    if (obj) {
                                        this.gscode = obj.gscode;
                                        this.addProject(obj)
                                    }
                                })
                            }
                        })
                    },
                    addProject(obj) {
                        //区域经理审批意见
                        if(!this.qyjlspyj){
                            this.qyjlspyj = obj.yidishpyj||null;
                        }
                        if(!this.shouyiareacode){
                            this.shouyiareacode = obj.shouyiarea||null;
                        }
                        // console.log("获取到的是南通单list",obj)
                        if(!this.order['costCenter' + obj.gscode]){
                            this.order['costCenter' + obj.gscode] = obj.costCenter||null;
                        }
                        if (obj.specialPrice) {
                            this.tejieshowflag = true;
                        }
                        if (obj.extraPrice) {
                            this.dingzhishowflag = true;
                        }
                        this.order.orderNetWorth = new big(obj.totalprice || 0).div(1.13).toFixed(2);
                        if (obj.orderztype == '发货单') {
                            this['productlist' + obj.gscode].push(obj);
                        } else {
                            this.productlist2.push(obj);
                        }
                    },
                    viewpress(r) {
                        this.showhistory = true;
                    },
                    handleSelectionChange9370(v){
                        this.chooseOrder9370 = v;
                        this.selectedList = v;
                    },
                    backtolist() {
                        this.$router.go(-1);
                    },
                    saveOrSubmit(v) {
                        if(v != '0' && (!this.selectedList || this.selectedList.length < 1)){
                            this.$msg.msge("请先勾选要处理的产品行!");
                            return;
                        }
                        if (v == '2') {
                            this.spform.optflag = '驳回'
                            if (!this.spform.shpyj) {
                                this.$msg.msge("驳回必须输入审批意见！");
                                return;
                            }
                        } else if (v == '1') {
                            this.spform.optflag = '通过'
                        } else {
                            //点击详情进来的
                            if (this.$route.query.f == '1') {
                                this.$router.back();
                                return;
                            }
                            this.$emit('refreshSelf',{close:true,refresh:false});
                            this.$router.go(-1);
                            return;
                        }
                        var confirmMsg =  "确认提交?";
                        this.$msg.confirm(confirmMsg, () => {
                            this.submitForm();
                        })
                    },
                    submitForm() {
                        this.spform.orderMainProductList = this.chooseOrder9370;
                        ss.OrderMainService.ydgshpsaveOrSubmit(this.spform).then(rd => {
                            this.$msg.alerts("提交成功！", () => {
                                //刷新右上角的代办个数
                                this.$store.dispatch("searchTasktotal")
                                //跳转回原页面
                                this.$router.go(-1);
                                return;
                            })
                        })
                    },


                }
            }

        </script>


<style scoped>
    .anniu {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.3rem;
    }


    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }

    .jieguo .jieguo_label {
        width: 1.5rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value {
        width: 20%;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0px 8px;
    }

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .hang {
        padding: 20px 0;
        background-color: white;
    }

    .bbbb {
        background-color: white;
        margin: 0 20px;

    }
</style>
<style>
    .showflowDialogcls .el-dialog__body{
        padding-top: 0px!important;
    }
    .h-formbLine .el-form-item__content .addredclass .el-input__inner{
        color: #ff7875;
    }
    .h-formbLine .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }

    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }

    .ljjtablepaddings .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
</style>
